import React from 'react';

import Location from '../Location';
import Division from '../Division';
import Role from '../Role';

import { Title, Text } from '../../styles';

interface ISlideProps {
  type: string;
  title: string;
  text?: string;
}

const Slide: React.FC<ISlideProps> = ({ type, title, text }) => {
  const getBody = (type: string): any => {
    if (type === 'location') {
      return <Location />;
    }
    if (type === 'division') {
      return <Division />;
    }
    if (type === 'role') {
      return <Role />;
    }
    return null;
  };
  return (
    <div>
      <Title>{title}</Title>
      {getBody(type)}
      <Text>{text}</Text>
    </div>
  );
};

export default Slide;
